
import type { PropType } from 'vue'
import type { ExplainSectionEnum } from '../../enums'
import type { ExplainMessages, RegularFilter } from '../../models'
import { defineComponent } from 'vue'
import ExplainSectionSelector from '../explain/explain-landing/explain-section-selector.component.vue'
import { EpbButton, EpbText } from '../shared'
import ExplainFilters from './explain-filters.component.vue'

export default defineComponent({
  name: 'ExplainHeader',
  components: {
    ExplainSectionSelector,
    EpbButton,
    EpbText,
    ExplainFilters,
  },
  props: {
    messages: {
      type: Object as PropType<ExplainMessages>,
      required: true,
    },
    filters: {
      type: Object as PropType<Record<string, RegularFilter>>,
      required: true,
    },
    showFilters: {
      type: Boolean,
      required: true,
    },
    showFiltersButton: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      baseClass: 'epb-explain-header',
    }
  },
  methods: {
    updateSection(sectionId: ExplainSectionEnum) {
      this.$emit('updateSection', sectionId)
    },
  },
})
